import { useEffect } from 'react';
import { useToasts } from 'react-toast-notifications';

function Toast() {
  const { addToast } = useToasts();
  const placement = 'top-left';

  const OnEventHandler = (event) => {
    if (event.data.event === 'toast') {
      addToast(
        event.data.msg,
        { autoDismiss: true, appearance: event.data.type, placement },
      );
    }
  };

  useEffect(() => {
    window.addEventListener('message', OnEventHandler);
    return () => {
      window.removeEventListener('message', OnEventHandler);
    };
  }, []);

  return null;
}

export default Toast;
